
/**
 * Vue Store to hold UI related data.
 *
 * @author Documill
 */


export default {

  state: {
    windowWidth:null,
    windowHeight:null,
    fullScreen:false
  },

  getters: {
    windowWidth (state) {
      return state.windowWidth;
    },

    windowHeight (state) {
      return state.windowHeight;
    },

    isMobile (state) {
      return state.windowWidth <=480;
    },

    isDeskTop(state) {
      return state.windowWidth > 1024;
    },
    isFullScreen(state) {
      return state.fullScreen;
    }

  },

  mutations: {
    setWindowWidth(state, width) {
      state.windowWidth = width;
    },

    setWindowHeight(state, height) {
      state.windowHeight = height;
    },
    setFullScreen(state,value) {
      state.fullScreen = value;
    }
  }

}
